import _ from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';

import moment from 'moment';

import { Link } from 'react-router-dom';

import { Page } from '../shared';

import ReactTooltip from 'react-tooltip';

import { fetchMyTeams } from '../../actions';

import {
  getSprintStatusTextForEmployee,
  getRatingClass,
} from '../../util';
import { getIcon } from '../../util/icons';

class TeamsPage extends Component {

  state = {
    searchText: '',
    pageMessage: null,
    currentTeamSprints: {},
    showingAllTodos: false,
  }

  componentWillMount(){
    //refetch team data if old
    if(this.props.myTeams){
      //console.log('RELOADING MY TEAM DATA');
      this.props.fetchMyTeams();
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot){
    if(this.props.team && _.size(this.props.team) > 0){
      console.log('componentDidUpdate:: team: ', this.props.team);
    }
  }

  getPageTodos(){
    const myTeams = this.getMyTeams();

    if(!myTeams || !myTeams[0]){
      return;
    }

    let combinedMemberData = {};

    _.each(myTeams, team => {
      _.each(team.memberData, (memberData, index) => {
        combinedMemberData[index] = memberData;
      });
    });

    // console.log('combinedMemberData: ', combinedMemberData);

    const todosDenominator = _.size(combinedMemberData);

    const todos = [{
      id: 1,
      task: 'Complete Talent Evaluations',
      needed: todosDenominator,
      done: _.reduce(combinedMemberData, (memo, member) => {
        return memo + (member.managerSetup.talentEvaluationComplete ? 1 : 0);
      }, 0),
    },{
      id: 2,
      task: 'Setup Velocity Sprints',
      needed: todosDenominator,
      done: _.reduce(combinedMemberData, (memo, member) => {
        return memo + (member.managerSetup.sprintSetup ? 1 : 0);
      }, 0),
    },{
      id: 3,
      task: 'Create Action Plans',
      needed: todosDenominator,
      done: _.reduce(combinedMemberData, (memo, member) => {
        return memo + (member.managerSetup.actionPlanDefined ? 1 : 0);
      }, 0),
    }/*,{
      id: 4,
      task: 'Conduct First Weekly Review',
      needed: todosDenominator,
      done: _.reduce(myTeam.memberData, (memo, member) => {
        return memo + (member.managerSetup.firstWeeklyReviewConductedForSprint ? 1 : 0);
      }, 0),
    }*/]

    const nextItem = _.filter(todos, todo => {
      return todo.done < todo.needed;
    })[0];

    const toatlItemsDone = _.reduce(todos, (memo, todo) => {
      return memo + todo.done;
    }, 0);
    const totalItemsNeeded = todosDenominator * todos.length;

    return {
      todos,
      nextItem,
      toatlItemsDone,
      totalItemsNeeded,
      percentComplete: Math.round((toatlItemsDone / totalItemsNeeded) * 100)
    }
  }

  renderSprintHistoryForMember(memberData){
    const memberSprintHistory = _.take(memberData.sprintHistory, 5);

    if(!memberSprintHistory || memberSprintHistory.length === 0){
      return null;
    }
    else{
      return (
        <div className="sprint-history">
          <h6>Past sprints</h6>
          <div className="sprint-ratings">
            {_.map(memberSprintHistory, sprintHistory => {
              //const combinedScore = sprintHistory.userRating + sprintHistory.managerRating;
              const sprintDateRangeString = moment(sprintHistory.startDate).format('M/D') + '-' + moment(sprintHistory.endDate).format('M/D')
              return <div data-tip={sprintDateRangeString + ' | User: ' + sprintHistory.userRating + '/5, Manager: ' + sprintHistory.managerRating + '/5'} key={sprintHistory.id} className={'sprint-rating ' + getRatingClass(sprintHistory.managerRating, 5)}>{sprintHistory.managerRating}</div>;
            })}
            <ReactTooltip effect="solid" place="top"/>
          </div>
        </div>
      )
    }
  }

  renderTeam(team){

    const pageTodos = this.getPageTodos();

    const showingTodos = pageTodos && pageTodos.percentComplete < 100;

    return (
      <div className="team" key={team._id}>
        <div className="name">{team.name}</div>

        <ul>
          {_.map(team.memberData, memberData => {

            const { managerSetupComplete, managerSetup } = memberData;

            const setupStepsComplete = (managerSetup.talentEvaluationComplete ? 1 : 0) + (managerSetup.sprintSetup ? 1 : 0) + (managerSetup.actionPlanDefined ? 1 : 0);

            console.log('determining sprint status for member: ', memberData);

            const profileAction = (managerSetupComplete ? 'sprint' : (!managerSetup.talentEvaluationComplete ? 'talents' : (!managerSetup.sprintSetup ? 'sprint/setup' : 'plan')));

            return <Link key={memberData._id} to={`/people/${memberData._id}/${profileAction}`}>
              <li className={`${memberData.currentSprintStatus === 'submitted' ? ' active' : ''} ${managerSetupComplete ? ' setup-complete' : ' setup-incomplete'}`}>
                <div className="member-photo">
                  <span className="initials">{memberData.firstName.substring(0,1).toUpperCase()}{memberData.lastName.substring(0,1).toUpperCase()}</span>
                </div>
                <div className="member-name">{memberData.firstName} {memberData.lastName}</div>

                {showingTodos && !managerSetupComplete &&
                  <div className="manager-setup-incomplete">
                    <div className="icon">{getIcon('settings')}</div>
                    <div className="text">Setup in progress ({setupStepsComplete}/3)</div>
                  </div>
                }

                {showingTodos && managerSetupComplete &&
                  <div className="manager-setup-complete">
                    <div className="icon">{getIcon('check-fill')}</div>
                    <div className="text">Setup complete (3/3)</div>
                  </div>
                }

                {!managerSetupComplete &&
                  <div className="manager-setup-steps">
                    <div className={`step ${managerSetup.talentEvaluationComplete ? ' is-complete' : ''}`}>
                      <div className="step-icon">{getIcon('talents')}</div>
                      <div className="step-name">Talent Evaluation Complete</div>
                    </div>
                    <div className={`step ${managerSetup.sprintSetup ? ' is-complete' : ''}`}>
                      <div className="step-icon">{getIcon('sprint')}</div>
                      <div className="step-name">Sprint Setup</div>
                    </div>
                    <div className={`step ${managerSetup.actionPlanDefined ? ' is-complete' : ''}`}>
                      <div className="step-icon">{getIcon('plan')}</div>
                      <div className="step-name">Action Plan Defined</div>
                    </div>
                    {/*<div className={`step ${managerSetup.firstWeeklyReviewConductedForSprint ? ' is-complete' : ''}`}>
                      <div className="step-icon">{getIcon('history')}</div>
                      <div className="step-name">First Weekly Review</div>
                    </div>*/}
                  </div>
                }

                {managerSetupComplete &&
                  <div className={`sprint-status ${memberData.currentSprintStatus}`}>
                    <div className={`step`}>
                      <div className="step-icon">{getIcon('sprint')}</div>
                      {memberData.currentSprintStatus === 'editing' &&
                        <div className="step-name">Employee editing {!memberData.firstWeeklyReviewConductedForSprint ? 'first ' : 'current '}sprint</div>
                      }
                      {memberData.currentSprintStatus === 'submitted' &&
                        <div className="step-name">Employee submitted {!memberData.firstWeeklyReviewConductedForSprint ? 'first ' : ''}sprint</div>
                      }
                    </div>
                  </div>
                }

                {this.renderSprintHistoryForMember(memberData)}

                {!managerSetupComplete &&
                  <button className="member-action button blue-button sm">CONTINUE SETUP</button>
                }
                {managerSetupComplete && memberData.currentSprintStatus === 'submitted' &&
                  <button className="member-action button primary sm">VIEW SPRINT REPORT</button>
                }
                {managerSetupComplete && memberData.currentSprintStatus !== 'submitted' &&
                  <button className="member-action button grey-button sm">VIEW SPRINT PROGRESS</button>
                }
              </li>
            </Link>
          })}
        </ul>

        {/*this.renderTeamLinks(team)*/}
      </div>
    )
  }

  getMyTeams(){
    const { myTeams } = this.props;

    console.log('myTeams: ', myTeams);

    if(!myTeams || _.size(myTeams) === 0){
      return [];
    }

    const sortedTeams = _.sortBy(myTeams, team => {
      return team.name;
    });

    const currentUserId = this.props.user.uid;

    const myTeamsSorted = _.filter(sortedTeams, team => {
      return team.leaders.indexOf(currentUserId) !== -1;
    });

    return myTeamsSorted;
  }

  renderTeams(){
    const myTeams = this.getMyTeams();

    if(myTeams.length > 1){
      return (
        <template>
          <ul className="teams-list">
            {_.map(myTeams, this.renderTeam.bind(this))}
          </ul>
        </template>
      )
    }
    else if(myTeams.length === 1){
      return this.renderTeam(myTeams[0]);
    }
    else{
      return (
        <div className="page-section">
          <h1>My Teams</h1>
          <p>You aren't managing any teams. If this is incorrect, please contact your organization administrator.</p>
        </div>
      );
    }
  }

  renderPageTodos(){
    const pageTodos = this.getPageTodos();

    const { showingAllTodos } = this.state;

    console.log('pageTodos: ', pageTodos);

    if(!pageTodos){
      return null;
    }

    const { todos, nextItem, percentComplete } = pageTodos;

    //everything done, don't show todos
    if(percentComplete >= 100){
      return null;
    }

    return (
      <div className="page-todos">
        {!showingAllTodos &&
          <h4>Get Your Team{_.size(this.props.myTeams) > 1 ? 's' : ''} Setup:</h4>
        }

        <div className="todo-progress">
          <span className="progress" style={{width: percentComplete + '%'}}></span>
        </div>
        <div className="todo-amount">{percentComplete}% COMPLETE</div>

        {!showingAllTodos && nextItem &&
          <div className="next-item">Next Up: {`${nextItem.task} (${nextItem.done}/${nextItem.needed})`}</div>
        }

        {showingAllTodos &&
          <ul className="all-items">
            {_.map(todos, todo => {
              let classes = '';
              if(todo.id === nextItem.id){
                classes += ' is-next-item';
              }
              if(todo.needed === todo.done){
                classes += ' is-complete';
              }
              return(
                <li key={todo.id} className={classes}>{`${todo.task} (${todo.done}/${todo.needed})`}</li>
              )
            })}
          </ul>
        }
        {!showingAllTodos &&
          <div className="see-all-toggle" onClick={() => { this.setState({ showingAllTodos: true }) }}>show all todos</div>
        }
        {showingAllTodos &&
          <div className="see-all-toggle" onClick={() => { this.setState({ showingAllTodos: false }) }}>collapse todos</div>
        }
      </div>
    );
  }

  render(){

    const userRole = (this.props.user || {}).role;

    const loading = !this.props.myTeams;

    return (
      <Page
        pageClass="teams"
        permissionRequired="view_teams_page"
        loading={loading}
        hideSidebar={true}
        pageMessage={this.state.pageMessage}
        clearMessage={() => { this.setState({ pageMessage: null }) }}
      >
        {this.renderPageTodos()}
        <div className={`teams-list-and-search list-only`}>
          {this.renderTeams()}
        </div>
      </Page>
    )
  }
}

function mapStateToProps(state){
  return {
    user: state.user,
    myTeams: state.myTeams.data
  }
}

export default connect(mapStateToProps, { fetchMyTeams })(TeamsPage);



// WEBPACK FOOTER //
// ./src/components/teams/index.js